<app-juvo-dialog
  [title]="articleName || ''"
  [type]="dialogType"
  titleType="neutral"
  titleAlign="left"
  [showCloseIcon]="true"
  [showFooter]="true"
  [cancelText]="translations['cancel']"
  [confirmText]="isEditing ? translations['editOrder'] : translations['addToCart']"
  [confirmIcon]="'shopping-cart'"
  (cancel)="closeModal()"
  (confirm)="addToOrder()"
  [confirmDisabled]="isAddToOrderDisabled()"
  [isStandaloneOverlay]="false" 
>
  <div class="product-dialog-content">
    
    <app-singleproduct-header
      [formGroup]="formGroup"
      [decimalPrecision]="decimalPrecision"
      [isLongMode]="isLongMode">
    </app-singleproduct-header>

    <app-singleproduct-prices
      [formGroup]="formGroup"
      [decimalPrecision]="decimalPrecision">
    </app-singleproduct-prices>

    <app-singleproduct-modifiers
      [modifierGroupsFormGroups]="getModifierGroupsAsFormGroups()"
      [translations]="translations"
      [decimalPrecision]="decimalPrecision">
    </app-singleproduct-modifiers>

    <app-singleproduct-suggestions
      [translations]="translations"
      [decimalPrecision]="decimalPrecision"
      [suggestionItems$]="suggestionItems$"
      (addSuggestionItem)="addSuggestionItem($event)">
    </app-singleproduct-suggestions>

    <app-singleproduct-note
      [formGroup]="formGroup"
      [translations]="translations">
    </app-singleproduct-note>
  </div>
</app-juvo-dialog>
